
/*
 * ! @chakra-ui/vue v0.13.1 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { H as HTMLElement } from './index-2216d089.js';
import './chakra-ui-styled-system.esm-a8a2e91f.js';
import './internal-icons-3bdf43cd.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-de5da461.js';
import './anime.es-fe1e1e1f.js';
import './CBox.js';
import './index-ff45b78b.js';
import './closebutton.styles-bab00868.js';
import './CTransition.js';
import { CModal, CModalContent, CModalOverlay, CModalBody, CModalHeader, CModalFooter, CModalCloseButton } from './CModal.js';
import './CPortal.js';
import './CNoSsr.js';
import './props.types-cbb7b1ff.js';

/**
 * Hey! Welcome to @chakra-ui/vue AlertDialog
 *
 * AlertDialog component is used interrupt the user with
 * a mandatory confirmation or action.
 *
 * An alert dialog is a modal dialog that interrupts the user's
 * workflow to communicate an important message and acquire a response.
 * Examples include action confirmation prompts and error message confirmations.
 * The `alertdialog` role enables assistive technologies and browsers to
 * distinguish alert dialogs from other dialogs so they have the option
 * of giving alert dialogs special treatment, such as playing a system alert sound.
 *
 * @see Docs     https://vue.chakra-ui.com/alertdialog
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CAlertDialog/CAlertDialog.js
 * @see A11y     https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CAlertDialog/accessibility.md
 * @see WAI-ARIA https://www.w3.org/TR/wai-aria-practices-1.2/#alertdialog
 */

var formatIds = function formatIds(id) {
  return {
    content: "alert-dialog-" + id,
    header: "alert-dialog-" + id + "-label",
    body: "alert-dialog-" + id + "-desc"
  };
};
/**
 * CAlertDialog component
 *
 * The wrapper for alertdialog components. It provides context and state for the dialog.
 *
 * @extends CModal
 * @see Docs https://vue.chakra-ui.com/alertdialog
 */


var CAlertDialog = {
  name: 'CAlertDialog',
  functional: true,
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    leastDestructiveRef: [HTMLElement, Object, String, Function]
  },
  render: function render(h, ref) {
    var slots = ref.slots;
    var props = ref.props;
    var data = ref.data;
    return h(CModal, {
      props: {
        isOpen: props.isOpen,
        onClose: props.onClose,
        initialFocusRef: props.leastDestructiveRef,
        formatIds: formatIds
      },
      attrs: Object.assign({}, data.attrs, {
        'data-chakra-component': 'CAlertDialog'
      })
    }, slots().default);
  }
};
/**
 * CAlertDialogContent component
 *
 * The wrapper for the alert dialog's content.
 *
 * @extends CModalContent
 * @see Docs https://vue.chakra-ui.com/alertdialog
 */

var CAlertDialogContent = {
  name: 'CAlertDialogContent',
  functional: true,
  render: function render(h, ref) {
    var data = ref.data;
    var slots = ref.slots;
    return h(CModalContent, {
      attrs: Object.assign({}, {
        role: 'alertdialog'
      }, data.attrs, {
        'data-chakra-component': 'CAlertDialogContent'
      })
    }, slots().default);
  }
};
/**
 * CAlertDialogOverlay component
 *
 * The dimmed overlay behind the dialog.
 *
 * @extends CModalOverlay
 * @see Docs https://vue.chakra-ui.com/alertdialog
 */

var CAlertDialogOverlay = Object.assign({}, CModalOverlay, {
  name: 'CAlertDialogOverlay'
});
/**
 * CAlertDialogBody component
 *
 * Should contain the description announced by screen readers
 *
 * @extends CModalBody
 * @see Docs https://vue.chakra-ui.com/alertdialog
 */

var CAlertDialogBody = Object.assign({}, CModalBody, {
  name: 'CAlertDialogBody'
});
/**
 * CAlertDialogHeader component
 *
 * Should contain the title announced by screen readers
 *
 * @extends CModalHeader
 * @see Docs https://vue.chakra-ui.com/alertdialog
 */

var CAlertDialogHeader = Object.assign({}, CModalHeader, {
  name: 'CAlertDialogHeader'
});
/**
 * CAlertDialogFooter component
 *
 * Should contain the actions of the dialog
 *
 * @extends CModalFooter
 * @see Docs https://vue.chakra-ui.com/alertdialog
 */

var CAlertDialogFooter = Object.assign({}, CModalFooter, {
  name: 'CAlertDialogFooter'
});
/**
 * CAlertDialogCloseButton component
 *
 * The button that closes the dialog.
 *
 * @extends CModalCloseButton
 * @see Docs https://vue.chakra-ui.com/alertdialog
 */

var CAlertDialogCloseButton = Object.assign({}, CModalCloseButton, {
  name: 'CAlertDialogCloseButton'
});

export { CAlertDialog, CAlertDialogBody, CAlertDialogCloseButton, CAlertDialogContent, CAlertDialogFooter, CAlertDialogHeader, CAlertDialogOverlay };
